<template>
  <!-- update Modal -->
  <div v-if="UpgradeModal" class="upgrade-dialog">
    <v-dialog
      overlay-opacity="0.97"
      persistent
      v-model="UpgradeModal"
      max-width="350"
      class="blur"
    >
      <v-card>
        <v-toolbar dense color="#00E676" class="text-h6" dark>
          Get Full Access
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text class="text-center text-h6 font-weight-bold pa-1">
          Upgrade Now & Get Access to ALL Features.
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="blue darken-1 white--text"
            text
            @click="$emit('closeModal')"
          >
            No, Thanks
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1 white--text" text @click="goToUpgrade">
            Upgrade Now
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
  <!-- update Modal ends..-->
</template>

<script>
export default {
  name: "upgradeModal2",
  props: {
    UpgradeModal: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    goToUpgrade() {
      this.$router.push({ name: "upgradePlan" });
    },
  },
};
</script>

<style></style>
